import Recording from 'components/recording/Recording';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProjectActions } from 'store/actionCreators';

const RecordingContainer = () => {
  const { pcode: projectCode } = useParams() as { pcode: string };

  useEffect(() => {
    ProjectActions.fetch_project_request(projectCode);
  }, []);

  return <Recording />;
};

export default RecordingContainer;
